import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DevExtremeModule} from '../../devextreme.module';
import {PanelAliasesDialogComponent} from './panel-aliases-dialog.component';

/** CR-20260928-002. Small on purpose: Application Settings imports it; it must not pull the workspace module in. */
@NgModule({
    imports: [CommonModule, DevExtremeModule],
    declarations: [PanelAliasesDialogComponent],
    exports: [PanelAliasesDialogComponent]
})
export class PanelAliasesModule {
}
